import { RangeChangeEventDetail } from "@ionic/core";
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
  IonBackButton,
  IonButtons,
  useIonViewWillEnter,
  useIonViewWillLeave,
  useIonViewDidEnter,
  useIonModal,
  IonButton,
  IonIcon,
} from "@ionic/react";
import { contract, options, optionsSharp } from "ionicons/icons";
import React from "react";
import { useState } from "react";
import { useContext } from "react";
import AVSettings from "../components/AudioVisualizer/AVSettings";
import { AppContext } from "../components/AppContext";
import useWindowSize from "../lib/useWindowSize";
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import AVComponent from "../components/AudioVisualizer/AVComponent";
import { useTranslation } from "react-i18next";

const AudioVisualizer: React.FC = () => {
  const [width, height] = useWindowSize();
  const handle = useFullScreenHandle();
  const [isRunning, setIsRunning] = useState(false);
  const [sensitivity, setSensitivity] = useState(1.03);
  const { t } = useTranslation();
  const {
    tabBar: { setTabBarHidden },
  } = useContext(AppContext);
  useIonViewWillEnter(() => setTabBarHidden(true));
  useIonViewDidEnter(() => {
    setIsRunning(true);
  });
  useIonViewWillLeave(() => {
    setIsRunning(false);
    setTabBarHidden(false);
    handleDismiss();
  });

  const handleSensitivity = (e: CustomEvent<RangeChangeEventDetail>) => {
    setIsRunning(false);
    setSensitivity(e.detail.value as number);
  };

  const handleDismiss = () => {
    setIsRunning(true);
    dismiss();
  };

  const [present, dismiss] = useIonModal(AVSettings, {
    handle,
    isRunning,
    setIsRunning,
    sensitivityValue: sensitivity,
    handleDismiss,
    handleSensitivity,
  });
  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton defaultHref="/" />
          </IonButtons>
          <IonButtons slot="end">
            <IonButton
              onClick={() => {
                setIsRunning(false);
                present({
                  initialBreakpoint: 0.35,
                  breakpoints: [0, 0.35, 0.85],
                  backdropBreakpoint: 0,
                  backdropDismiss: true,
                });
              }}
            >
              <IonIcon icon={options} md={optionsSharp} />
            </IonButton>
          </IonButtons>
          <IonTitle>{t(`Audio Visualizer.title`)}</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <FullScreen
          handle={handle}
          className="relative flex items-center justify-center bg-black"
        >
          {handle.active && (
            <button onClick={handle.exit}>
              <IonIcon
                icon={contract}
                className="text-primary-50/30 hover:text-primary-50/80 fixed bottom-4 right-4 h-6 w-6"
              />
            </button>
          )}
          <AVComponent
            sensitivity={sensitivity}
            {...{ isRunning, width, height }}
          />
        </FullScreen>
      </IonContent>
    </IonPage>
  );
};

export default AudioVisualizer;
